// Core packages
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";

// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";

/**
 * Script start
 */
@Component({
  selector: "app-structure-setting-options-dialog",
  templateUrl: "./structure-setting-options-dialog.component.html",
  styleUrls: ["./structure-setting-options-dialog.component.scss"],
})
export class StructureSettingOptionsDialogComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  dialogIsLoading = true; // Used to view/hide form loading spinner
  title = "";

  // BEGIN - Edit item form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  subForm: FormGroup = new FormGroup({});
  newSubForm: FormGroup = new FormGroup({});
  model: any = {};
  subModel: any = {};
  newSubModel: any = {};
  fields: FormlyFieldConfig[] = [];
  subFields: FormlyFieldConfig[] = [];
  newSubFields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  subOptions: FormlyFormOptions = {};
  newSubOptions: FormlyFormOptions = {};

  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true,
    },
  };
  
  /**
   * Class constructor
   */
   constructor(
    public dialogRef: MatDialogRef<StructureSettingOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private configService: ConfigService,
    private translateService: TranslateService,
    private authService: AuthService,
    private cookieService: CookieService,
    private toastrService: ToastrService,
    private helperService: HelperService,
    private settingsService: SettingsService
  ) {}

  
  /**
   * Init components
   *
   * @since 1.0.0
   */
   ngOnInit(): void {
     
    this.initForm();
  }
  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
   initForm(): void {
    this.fields = [];
    this.model = this.data;

    this.fields = [
      {
        key: 'options',
        type: 'repeat-structure-options',
        templateOptions: {
          addText: 'Aggiungi una nuova opzione',
        },
        fieldArray: {
          fieldGroup: [
            {
              key: "_id",
              defaultValue: "",
              templateOptions: {
                type: "hidden",
              },
            },
            {
              key: "value",
              defaultValue: "",
              templateOptions: {
                type: "hidden",
              },
            },
            {
              key: "label",
              defaultValue: "",
              templateOptions: {
                type: "hidden",
              },
            },
            {
              className: "col-12",
              type: "input",
              key: "translation.it",
              templateOptions: {
                label: this.translateService.instant("settings.document.it"),
                placeholder: this.translateService.instant(
                  "settings.document.it"
                ),
                required: true,
                minLength: 2,
                maxLength: 500,
              },
            },
            {
              className: "col-12",
              type: "input",
              key: "translation.en",
              templateOptions: {
                label: this.translateService.instant("settings.document.en"),
                placeholder: this.translateService.instant(
                  "settings.document.en"
                ),
                required: true,
                minLength: 2,
                maxLength: 500,
              },
            },
          ],
        },
      },
    ];

    this.dialogIsLoading = false;
   }
   
  /**
   * Handle dialog Submit
   *
   * @since 1.0.0
   */
  onFormSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsTouched();
      });
      console.warn("form", this.form);
      this.toastrService.error(
        this.translateService.instant("common.errors.form_is_invalid")
      );
      return;
    }
    // Activate submit button loading status
    // this.formBtnOptions.active = true;

    if (this.model && this.model.options && Array.isArray(this.model.options)) {
      this.model.options.forEach((el: any, index: number) => {
        if (el.value === '') {
          el.value = `option-${index}`;
        }
        if (el.label === '') { 
          el.label = `properties.structures.types.option-${index}`;
        }
      });
    }

    const res = {
      status: true,
      data: this.model,
    }
    this.dialogRef.close(res);
  }

  /**
   * Handle dialog denial
   *
   * @since 1.0.0
   */
  onClose(data?: any): void {
    this.dialogRef.close();
  }
}
